module.exports = __webpack_public_path__ + "img/two@3x.49b3b697.png";